import { OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UserModel } from 'e5core-angular-services';

export class E5coreUiAssignUserBaseComponent implements OnInit {
  @Input() users : UserModel[];
  @Input() showAssignButton: boolean;
  @Input() readonly: boolean;
  @Input() loading: boolean = false ;

  @Output() selectUserEvent = new EventEmitter();
  @Output() assignUserEvent = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
  }

  public selectUser(event): void {
    this.selectUserEvent.emit(event);
  }

  public assignUser(): void {
    this.assignUserEvent.emit(event);
  }
  
  public get isReadOnly(): boolean {
    return (this.readonly);
  }
}